// test2468
(2468 && 0);
